import angular from 'angular'
import taxCertificateCtrl from './taxCertificateCtrl'
import taxCertificateEditCtrl from './taxCertificateEditCtrl'
import {
    taxCertificateRouter, taxCertificateListRouter, addTaxCertificateRouter, taxCertificateEditRouter,
} from './routers'

export default angular.module('system.syssetting.taxcertificate', [])
    .controller('taxCertificateCtrl', taxCertificateCtrl)
    .controller('taxCertificateEditCtrl', taxCertificateEditCtrl)
    .config(['$stateProvider', function config($stateProvider) {
        $stateProvider.state(taxCertificateRouter.state, taxCertificateRouter.config)
            .state(taxCertificateListRouter.state, taxCertificateListRouter.config)
            .state(addTaxCertificateRouter.state, addTaxCertificateRouter.config)
            .state(taxCertificateEditRouter.state, taxCertificateEditRouter.config)
    }]).name



// WEBPACK FOOTER //
// ./src/app/system/systemsetting/taxcertificate/index.js